import {
    TextField,
    Stack,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { SectionCard, SectionTitle } from './Formstyle';

const PaymentInfo = ({ user }) => {
    const profile = user?.profile;

    if (!profile) return null;

    const ReadField = ({ label, value }) => (
        <TextField
            label={label}
            value={value || '-'}
            size="small"
            fullWidth
            disabled
            variant="outlined"
        />
    );

    return (
        <SectionCard>
            <SectionTitle>Dados de Recebimento</SectionTitle>

            <Stack spacing={2.5}>
                {/* Dados Pessoais */}
                <Stack spacing={2}>
                    <Typography variant="body2" color="text.secondary" fontWeight={500}>
                        Informações pessoais
                    </Typography>
                    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                        <ReadField label="Documento" value={`${profile.document_type}: ${profile.document}`} />
                        <ReadField label="Titular" value={profile.holder} />
                        <ReadField label="Data de nascimento" value={profile.birthdate ? new Date(profile.birthdate).toLocaleDateString('pt-BR') : ''} />
                        <ReadField label="Renda mensal" value={profile.monthly_income ? `R$ ${Number(profile.monthly_income).toLocaleString('pt-BR')}` : ''} />
                        <ReadField label="Ocupação" value={profile.professional_occupation} />
                        <ReadField label="Telefone" value={profile.phone} />
                    </Box>
                </Stack>

                {/* Endereco */}
                <Accordion
                    disableGutters
                    elevation={0}
                    sx={{
                        border: '1px solid #e8e8e8',
                        borderRadius: '8px !important',
                        '&:before': { display: 'none' },
                    }}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="body2" fontWeight={500}>Endereço</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                            <ReadField label="CEP" value={profile.zipcode} />
                            <ReadField label="Rua" value={profile.street} />
                            <ReadField label="Cidade" value={profile.city} />
                            <ReadField label="Estado" value={profile.state} />
                            <ReadField label="Bairro" value={profile.neighborhood} />
                            <ReadField label="Complemento" value={profile.complement} />
                            <ReadField label="Número" value={profile.number} />
                            <ReadField label="Ponto de referência" value={profile.reference_point} />
                        </Box>
                    </AccordionDetails>
                </Accordion>

                {/* Dados Bancarios */}
                <Accordion
                    disableGutters
                    elevation={0}
                    sx={{
                        border: '1px solid #e8e8e8',
                        borderRadius: '8px !important',
                        '&:before': { display: 'none' },
                    }}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <AccountBalanceIcon sx={{ fontSize: 18, color: '#666' }} />
                            <Typography variant="body2" fontWeight={500}>Dados bancários</Typography>
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                            <ReadField label="Banco" value={profile.bank_number} />
                            <ReadField label="Tipo da conta" value={profile.account_type === 'checking' ? 'Corrente' : 'Poupanca'} />
                            <ReadField label="Agência" value={`${profile.agency_number}${profile.agency_digit ? '-' + profile.agency_digit : ''}`} />
                            <ReadField label="Conta" value={`${profile.account_number}-${profile.account_digit}`} />
                        </Box>
                    </AccordionDetails>
                </Accordion>

                <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'center', mt: 1 }}>
                    Para alterar dados de recebimento, entre em contato com o suporte.
                </Typography>
            </Stack>
        </SectionCard>
    );
};

export default PaymentInfo;
